import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { SearchHotelComponent } from 'src/app/components/search-hotel/search-hotel.component';
import * as moment from 'moment';
import { BlocksService } from 'src/app/api/report/blocks.service';
import { ToolsService } from 'src/app/utils/tools.service';
declare var $: any;

@Component({
  selector: 'app-blockshotel-form',
  templateUrl: './blockshotel-form.component.html',
  styleUrls: ['./blockshotel-form.component.css']
})
export class BlockshotelFormComponent implements OnInit {
  @ViewChild(SearchHotelComponent) SearchHotelComponent: any;

  private thisComponent: BlockshotelFormComponent;
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  bookings: any = [];
  hotelSelected: any = null;
  all_data: boolean = false; // seleccionar todos los items de las reservas
  is_all: boolean = false;
  start_range: any = moment().startOf('month');
  end_range: any = moment().endOf('month');

  hotelsbooking_selecteds: any = [];
  detailbedrooms_selecteds: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private blocksService: BlocksService,
    private route: ActivatedRoute,
    private toolsService: ToolsService,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      date_start: [null],
      date_end: [null],
      hotel_id: [null],
      previous_balance: [null],
      total_block: [null],
      total_paid: [null],
      total_balance: [null],
      observation: [null],
      is_all: [false]
    });
  }

  ngOnInit() {
    let component_ = this.thisComponent;
    (<any>$('#date_range')).daterangepicker(
      {
        locale: {
          format: 'YYYY-MM-DD'
        },
        startDate: component_.start_range,
        endDate: component_.end_range,
        showDropdowns: true
      },
      function(start_date: any, end_date: any) {
        component_.start_range = start_date;
        component_.end_range = end_date;
      }
    );
    // this.navigationTrackerService.initializeMenu(this.route);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  list() {
    let val_params =
      'hotel_id=' +
      this.hotelSelected.id +
      '&is_all=' +
      this.is_all +
      '&start_range=' +
      this.start_range.format('YYYY-MM-DD') +
      '&end_range=' +
      this.end_range.format('YYYY-MM-DD');
    this.blocksService.blocksHotelSummary(val_params).subscribe({
      next: (data: any) => {
        this.bookings = data.results;
        if (this.bookings.length > 0) {
          for (let i in this.bookings) {
            for (let j in this.bookings[i].detail_bedrooms) {
              this.bookings[i].detail_bedrooms[j].is_selected = false;
            }
          }

          setTimeout(() => {
            (<any>$('#total_block')).attr('disabled', 'true');
          }, 150);
        }
      }
    });
  }

  preventList() {
    this.list();
  }

  selectedHotelSearch(item_: any) {
    this.hotelSelected = item_;
    this.item.patchValue({
      hotel_id: item_.id
    });
    this.preventList();
  }

  removeHotel() {
    this.hotelSelected = null;
    this.item.patchValue({
      hotel_id: null
    });
    this.clearData();

    setTimeout(() => {
      this.SearchHotelComponent.focused();
    }, 250);
  }

  clearData() {
    this.bookings = [];
  }

  selectedAllBooking() {
    if (this.all_data) {
      this.hotelsbooking_selecteds = [];
      this.detailbedrooms_selecteds = [];
      for (let i in this.bookings) {
        for (let j in this.bookings[i].detail_bedrooms) {
          this.bookings[i].detail_bedrooms[j].is_selected = true;
          this.selectedBooking(this.bookings[i].detail_bedrooms[j], i, j);
        }
      }
    } else {
      for (let i in this.bookings) {
        for (let j in this.bookings[i].detail_bedrooms) {
          this.bookings[i].detail_bedrooms[j].is_selected = false;
        }
      }
      this.hotelsbooking_selecteds = [];
      this.detailbedrooms_selecteds = [];
      this.calculateBalance();
    }
  }

  selectedBooking(booking: any, index_parent: any, index_child: any) {
    booking.id = booking.detail_id;
    let validate_ = this.toolsService.notExistObjInArr(
      booking,
      this.detailbedrooms_selecteds
    );
    if (validate_) {
      this.bookings[index_parent].detail_bedrooms[
        index_child
      ].is_selected = true;
      this.detailbedrooms_selecteds.push(booking);
    } else {
      let index = this.detailbedrooms_selecteds.indexOf(booking);
      this.bookings[index_parent].detail_bedrooms[
        index_child
      ].is_selected = false;
      this.detailbedrooms_selecteds.splice(index, 1);
    }
    this.setHotelsBooking();
    this.calculateBalance();
  }

  setHotelsBooking() {
    this.hotelsbooking_selecteds = [];
    for (let key in this.detailbedrooms_selecteds) {
      if (
        !this.hotelsbooking_selecteds.includes(
          this.detailbedrooms_selecteds[key].hotelsbooking_id
        )
      ) {
        this.hotelsbooking_selecteds.push(
          this.detailbedrooms_selecteds[key].hotelsbooking_id
        );
      }
    }
  }

  calculateBalance() {
    let total_block = 0;
    for (let i in this.detailbedrooms_selecteds) {
      total_block =
        Number(total_block) + Number(this.detailbedrooms_selecteds[i].subtotal);
    }
    this.item.patchValue({
      total_block: total_block.toFixed(2)
    });
  }

  onSubmit() {
    this.submitted = true;
    this.item.patchValue({
      date_start: this.start_range.format('YYYY-MM-DD'),
      date_end: this.end_range.format('YYYY-MM-DD')
    });

    if (this.item.invalid) {
      return;
    }

    let data: any = {};
    data.item = this.item.value;
    data.hotelsbooking_selecteds = this.hotelsbooking_selecteds;
    data.detailbedrooms_selecteds = this.detailbedrooms_selecteds;
    if (this.validate()) {
      if (this.isEdit) {
        // this.brandService.update(this.checkId, this.item.value).subscribe({
        //   next: (data: any) => {
        //     this.alertifyMsg.success('Registro actualizado con éxito');
        //     this.cancel();
        //   }
        // });
      } else {
        this.blocksService.blocksHotelSave(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/reportes/cuadreshotel/lista'
    ]);
  }
}
